import React from 'react'
import loadScript from 'load-script'

const GOOGLE_SDK_URL = 'https://apis.google.com/js/api.js'
const CLIENT_ID =
  '899041326187-9js9hht6jff6ojujhrhv710ashme1cq1.apps.googleusercontent.com'
const API_KEY = 'AIzaSyDzvY7o-VLGJBxCctCAtSs8zxVHpzRiMxc'
const SCOPES = [
  // 'https://www.googleapis.com/auth/drive.readonly',
  // 'https://www.googleapis.com/auth/drive',
  'https://www.googleapis.com/auth/drive.metadata.readonly',
]
var DISCOVERY_DOCS = [
  'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest',
]

class GoogleDriveContainer extends React.Component {
  state = { files: [] }

  componentDidMount() {
    loadScript(GOOGLE_SDK_URL, this.onApiLoad)
  }

  onApiLoad = () => {
    window.gapi.load('client:auth2', this.initClient)
  }

  initClient = () => {
    console.info('init client')
    window.gapi.client
      .init({
        apiKey: API_KEY,
        clientId: CLIENT_ID,
        discoveryDocs: DISCOVERY_DOCS,
        scope: 'https://www.googleapis.com/auth/drive.metadata.readonly',
      })
      .then(() => {
        console.info('Listen for sign-in state changes.')
        window.gapi.auth2
          .getAuthInstance()
          .isSignedIn.listen(this.updateSigninStatus)
      })
      .catch(error => {
        console.error(error)
      })
  }

  updateSigninStatus = () => {
    // Handle the initial sign-in state.
    const isSignedIn = window.gapi.auth2.getAuthInstance().isSignedIn.get()

    if (isSignedIn) {
      this.loadFiles()
    }

    this.setState({
      isSignedIn,
    })
  }

  handleAuthClick = () => {
    window.gapi.auth2.getAuthInstance().signIn()
  }

  handleSignoutClick = () => {
    window.gapi.auth2.getAuthInstance().signOut()
  }

  loadFiles = () => {
    window.gapi.client.drive.files
      .list({
        pageSize: 10,
        fields: 'nextPageToken, files(id, name)',
      })
      .then(response => {
        var files = response.result.files
        if (files && files.length > 0) {
          for (var i = 0; i < files.length; i++) {
            var file = files[i]
            console.log(file.name + ' (' + file.id + ')')
          }
          this.setState({ files })
        } else {
        }
        console.log('hello', response)
      })
  }

  printFile = fileId => {
    var request = window.gapi.client.drive.files.get({
      fileId: fileId,
    })
    request.execute(function(resp) {
      console.log(resp)
      console.log('Title: ' + resp.title)
      console.log('Description: ' + resp.description)
      console.log('MIME type: ' + resp.mimeType)
    })
  }

  render() {
    return (
      <div>
        <ul>
          {this.state.files.map(file => (
            <li>
              <a onClick={() => this.printFile(file.id)}> {file.name}</a>
            </li>
          ))}
        </ul>
        <button onClick={this.loadFiles}> show files </button>
        <button onClick={this.handleAuthClick}>Sign in</button>
        <button onClick={this.handleSignoutClick}>Sign out</button>
      </div>
    )
  }
}

export default GoogleDriveContainer



// WEBPACK FOOTER //
// ./src/modules/google-drive/GoogleDriveContainer.js